// ls存储唯一值
export default {
  globalShowAndCheckIdsAdMgtCards: 'globalShowAndCheckIdsAdMgtCards',
  // 销售统计
  ImmediateSalesFormLs: 'ImmediateSalesFormLs',
  // 应收明细 - 虾皮
  ReceivableDetailShopeeFormLs: 'ReceivableDetailShopeeFormLs',
  // 应收明细 - 拉赞大
  ReceivableDetailLazadaFormLs: 'ReceivableDetailLazadaFormLs',
  // 应收明细 - 速卖通
  ReceivableDetailAliExpressFormLs: 'ReceivableDetailAliExpressFormLs',
  // 广告日志
  AdLogFormLs: 'AdLogFormLs',
  // 广告管理
  AdManageFormLs: 'AdManageFormLs',
  // 秒杀
  SeckillFormLs: 'SeckillFormLs',
  // 店铺绩效
  ShopMeritFormLs: 'ShopMeritFormLs',
  // 店铺绩效详情
  ShopMeritDetailFormLs: 'ShopMeritDetailFormLs',
  // 商品表现
  ProductPerformanceFormLs: 'ProductPerformanceFormLs',
  // 订单列表
  OrderFormLs: 'OrderFormLs',
  // 请求评论
  RequestCommentsFormLs: 'RequestCommentsFormLs',
  // 利润报表-亚马逊
  ProfitStatementAmazon: 'ProfitStatementAmazon',
  // 利润报表-虾皮
  ProfitStatementShopee: 'ProfitStatementShopee',
  // 利润报表-拉赞大
  ProfitStatementLazada: 'ProfitStatementLazada',
  // 利润报表-速卖通
  ProfitStatementAliexpress: 'ProfitStatementAliexpress',
  // 销售利润
  SalesProfit: 'SalesProfit',
  // 首页时钟
  HomeOtherRegion: 'HomeOtherRegion',
  // 结算明细页面初始化 props
  // { showImportBillModal: boolean;  importBillModalType: 1}
  settlementDetailPageInitConfig: 'settlementDetailPageInitConfig',
}
